import { CSSProperties, HTMLAttributes, KeyboardEvent, useEffect, useState } from 'react';
import classNames from 'classnames';

type CheckboxProps = HTMLAttributes<HTMLDivElement> & {
  selected?: boolean;
  disabled?: boolean;
  label: string;
  customColor?: string;
  className?: string;
  boxClassName?: string;
  onChange: (isSelected: boolean) => void;
};

const Checkbox = ({
  selected = false,
  disabled = false,
  customColor,
  label,
  onChange,
  className = '',
  boxClassName = '',
  ...rest
}: CheckboxProps) => {
  const [isSelected, setSelected] = useState(selected);
  useEffect(() => {
    setSelected(selected);
  }, [selected]);
  const setState = (): void => {
    if (!disabled) {
      setSelected((prev) => !prev);
      onChange(isSelected);
    }
  };
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Space' || e.key === 'Enter') {
      setState();
    }
  };
  const style: CSSProperties | undefined = customColor
    ? ({ '--custom-color': customColor } as CSSProperties)
    : undefined;
  return (
    <div
      {...rest}
      className={classNames('d-flex w-100 align-items-center checkbox-wrapper', className)}
      tabIndex={-1}
      role="checkbox"
      aria-checked={isSelected}
      onClick={setState}
      onKeyDown={(e) => handleKeyDown(e)}
    >
      <div
        className={classNames('checkbox d-flex', boxClassName, {
          selected: isSelected,
          'disabled ': disabled,
        })}
        style={style}
      >
        {isSelected && <em className="d-flex bi-check text-white" aria-hidden="true" />}
      </div>
      <p className={`field-dropdown-expanded-label ms-2 ${disabled ? 'disabled' : ''}`}>{label}</p>
    </div>
  );
};

export default Checkbox;
